// extracted by css-extract-rspack-plugin
export default {"root":"AtFnipKKNgVtBNMp","main":"FmHiiSfbfZghHBhe","logo":"deuoB2oYEbcfQj58","title":"KgvVIc22dDIdVexU","description":"FySFfKBSHoWDE2Iy","actions":"UndE12AN8vMvKvPA"};